import { put, call, takeLatest, select } from 'redux-saga/effects';

import { format, parse } from 'date-fns';

import { formatError } from '../../../libs';
import customerAPI from '../../api/customer';
import { Creators as AppCreators } from '../../reducers/app';
import { Types, Creators } from '../../reducers/customer';
import { signInUser } from '../../utils/cookiesUser';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* customerInfosRequest({ customerId, token, payload, changePassword }) {
  try {
    const validToken = (yield select(getToken)) || token;
    const { customer, app } = yield select(getState);

    const siteId = app.getIn(['config', 'siteId']);
    const domain = app.getIn(['config', 'domain']);
    let body = payload;
    let method = 'get';

    const validCustomerId = customerId || customer.getIn(['id']);

    if (body && !changePassword) {
      delete body.editable;
      delete body.edition;

      method = 'put';

      signInUser({ name: body.nickName, domain });

      if (body.type.personType === 'PJ') {
        delete body.type.pf;
      } else {
        delete body.type.pj;
      }
    }

    if (body && changePassword) {
      method = 'put';
      body = {
        type: customer.getIn(['type']).asMutable({ deep: true }),
        account: {
          ...customer.getIn(['account']).asMutable({ deep: true }),
          password: body.password,
          newPassword: body.newPassword,
        },
        telephones: customer.getIn(['telephones']).asMutable({ deep: true }),
        optIn: customer.getIn(['optIn']).asMutable({ deep: true }),
      };
    }

    if (body && body.type?.pf) {
      body.type.pf.birthday = format(parse(body.type.pf.birthday, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd');
    }

    const data = yield call(customerAPI.informations[method], validCustomerId, validToken, body, siteId);

    if (changePassword) {
      data.changeSuccess = true;
    }

    if (data.type?.pf?.birthday) {
      data.type.pf.birthday = new Date(`${data.type.pf.birthday}T00:00`).toLocaleDateString('pt');
    }

    yield put(Creators.customerInfosSuccess(data));

    if (body) {
      yield put(
        AppCreators.feedbackRequest({
          message: changePassword ? 'Senha alterada com sucesso' : 'Alterações salvas com sucesso',
          open: true,
          type: 'success',
        })
      );
      yield put(Creators.customerInfosRequest());
    }
  } catch (error) {
    const formatted = formatError(error);
    yield put(AppCreators.feedbackRequest({ message: formatted.message, open: true }));
    yield put(Creators.customerInfosFailed(formatted));
  }
}

export default function* watch() {
  yield takeLatest(Types.CUSTOMER_INFOS_REQUEST, customerInfosRequest);
}
